module.exports = __webpack_public_path__ + "img/yan.36230a07.jpg";